import { defineComponent, type PropType } from 'vue';
import route from '@router/route';
import { isEmpty, pickBy } from 'lodash-es';
import dayjs from 'dayjs';
import type { JobItemResource, AllowedOptionsResource } from './JobItemTypes';

/**
 * This mixin provides the common logic for jobCard and jobPost functionality
 */
export default defineComponent({
    name: 'JobItemMixin',
    props: {
        /**
         * The job preferences object
         */
        jobInfo: {
            type: Object as PropType<JobItemResource>,
            default: () => {},
        },
        /**
         * Enable score click and switch to preferences button
         */
        enableScoreClick: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            allowedOptionsType: [
                'job_type',
                'work_environment',
                'location',
                'employment_type',
                'industry',
            ],
        };
    },
    computed: {
        isExternalJob(): boolean {
            return this.jobInfo.isStSt;
        },
        isDisabled(): boolean {
            return this.jobInfo.score == null;
        },
        companyLink(): unknown {
            return this.jobInfo.company_website
                ? route('company.show', { companySlug: this.jobInfo.company_website })
                : '#';
        },
        options(): unknown {
            const jobPreferences = pickBy(
                this.jobInfo,
                (value, key) => !isEmpty(value) && (this.allowedOptionsType.includes(key) as unknown),
            );

            return Object.fromEntries(
                this.allowedOptionsType
                    .filter((item) => jobPreferences[item as keyof AllowedOptionsResource] !== undefined)
                    .map((key) => [key, jobPreferences[key as keyof AllowedOptionsResource]]),
            );
        },
        salary(): unknown {
            return this.jobInfo.salary_info?.salary_formatted;
        },
        salaryDetails(): unknown {
            return this.jobInfo.salary_info?.salary_details;
        },
        hasSalaryDetails(): unknown {
            return this.salary && this.salaryDetails;
        },
    },
    methods: {
        dayjs,
        isEmpty,
        getOptionsValues(option: unknown): unknown {
            return Array.isArray(option) ? option.map((item) => (item as { value: unknown }).value).join(', ') : option;
        },
    },
});
